import './App.css';
import Skills from './Components/Skills';
import { useState, useEffect } from 'react';
import Popup from './Components/Popup';
import Projects from './Components/Projects';
import Downloads from './Components/Downloads';
import GeminiChat from './Components/GeminiChat';
import BlueprintBackdrop from './Components/BlueprintBackdrop';
import { useSeitenBeobachter } from './seitenBeobachter';

function App() {
  // Lokale Zustaende fuer Popups, Technologien und Vorschaufenster
  const [zeigePopup, setZeigePopup] = useState(false);
  const [gewaehlteTechnologie, setGewaehlteTechnologie] = useState('');
  const [istProjektModalOffen, setIstProjektModalOffen] = useState(false);
  const [ausgewaehltesKartenRechteck, setAusgewaehltesKartenRechteck] = useState(null);

  // Scroll-Enthuellung (Fallback) und ScrollSpy fuer die Navigation
  useSeitenBeobachter();

  // Die Navbar liegt ausserhalb des React-Baums (statisches index.html) -- ueber eine
  // body-Klasse wird sie beim geoeffneten Popup mitgeblurrt wie der Rest der Seite.
  useEffect(() => {
    document.body.classList.toggle('popupAktiv', zeigePopup);
    return () => document.body.classList.remove('popupAktiv');
  }, [zeigePopup]);

  return (
    <main className="App">
      <BlueprintBackdrop />
      {/* Faehigkeiten- und Kompetenzbereich */}
      <Skills
        showPopup={zeigePopup}
        setShowPopup={setZeigePopup}
        tech={gewaehlteTechnologie}
        setTech={setGewaehlteTechnologie}
        setSelectedCardRect={setAusgewaehltesKartenRechteck}
      />

      {/* Projekt-Uebersicht */}
      <Projects
        isOpen={istProjektModalOffen}
        setIsOpen={setIstProjektModalOffen}
      />

      {/* Animiertes Detail-Popup fuer Technologien */}
      {zeigePopup && (
        <Popup
          tech={gewaehlteTechnologie}
          setShowPopup={setZeigePopup}
          selectedCardRect={ausgewaehltesKartenRechteck}
        />
      )}

      {/* Zertifikate- und Downloadbereich */}
      <Downloads />

      {/* Intelligenter KI-Chatassistent */}
      <GeminiChat />
    </main>
  );
}

export default App;
